"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__74a6e990a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.802 6.49a.7.7 0 0 1 .7.7v2.694a.3.3 0 0 0 .144.256l2.08 1.268a.7.7 0 1 1-.729 1.195l-2.08-1.268a1.7 1.7 0 0 1-.815-1.451V7.19a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.802 6.49a.7.7 0 0 1 .7.7v2.694a.3.3 0 0 0 .144.256l2.08 1.268a.7.7 0 1 1-.729 1.195l-2.08-1.268a1.7 1.7 0 0 1-.815-1.451V7.19a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m10.646 10.14-.78 1.28zm2.08 1.268.78-1.281zm-.729 1.195-.78 1.28zm-2.08-1.268.781-1.28zm2.085-4.145a2.2 2.2 0 0 0-2.2-2.2v3a.8.8 0 0 1-.8-.8zm0 2.694V7.19h-3v2.694zm-.575-1.025a1.2 1.2 0 0 1 .575 1.025h-3a1.8 1.8 0 0 0 .863 1.537zm2.08 1.268-2.08-1.268-1.562 2.562 2.08 1.268zm.733 3.024a2.2 2.2 0 0 0-.733-3.024l-1.562 2.561a.8.8 0 0 1-.267-1.099zm-3.024.733a2.2 2.2 0 0 0 3.024-.733l-2.562-1.562a.8.8 0 0 1 1.1-.267zm-2.08-1.268 2.08 1.268 1.562-2.562-2.08-1.267zM7.603 9.884a3.2 3.2 0 0 0 1.535 2.732l1.561-2.561a.2.2 0 0 1-.096-.171zm0-2.694v2.694h3V7.19zm2.2-2.2a2.2 2.2 0 0 0-2.2 2.2h3a.8.8 0 0 1-.8.8zM5.9 10A4.1 4.1 0 0 1 10 5.9v-3A7.1 7.1 0 0 0 2.9 10zm4.1 4.1A4.1 4.1 0 0 1 5.9 10h-3a7.1 7.1 0 0 0 7.1 7.1zm4.1-4.1a4.1 4.1 0 0 1-4.1 4.1v3a7.1 7.1 0 0 0 7.1-7.1zM10 5.9a4.1 4.1 0 0 1 4.1 4.1h3A7.1 7.1 0 0 0 10 2.9zm0-4.4A8.5 8.5 0 0 0 1.5 10h3A5.5 5.5 0 0 1 10 4.5zm8.5 8.5A8.5 8.5 0 0 0 10 1.5v3a5.5 5.5 0 0 1 5.5 5.5zM10 18.5a8.5 8.5 0 0 0 8.5-8.5h-3a5.5 5.5 0 0 1-5.5 5.5zM1.5 10a8.5 8.5 0 0 0 8.5 8.5v-3A5.5 5.5 0 0 1 4.5 10z",
  mask: "url(#ursa-icon__74a6e990a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ClockIcon20.js.map